module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921102651_T.19610bd3.jpg";